import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import HeaderBottom from '../HeaderBottom/HeaderBottom';

type IProps = {
  children: React.ReactNode;
  pathName?: string;
  showHeader?: boolean;
};
const Layout = ({ children, pathName, showHeader }: IProps) => {
  return (
    <>
      <Header />
      <main>
        {showHeader && <HeaderBottom pathName={pathName} />}

        <div
          style={{
            // backgroundColor: 'rgb(255 250 250)',
            paddingTop: '20px',
            marginBottom: '20px',
          }}
        >
          {children}
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Layout;
